export default class Hero {
	constructor() {
		const hero = document.querySelector( '[data-hero]' );

		if ( null === hero ) {
			return;
		}

		const switcher = hero.querySelector( '[data-hero-switcher]' );
		hero.classList.add( 'start' );
		hero.classList.add( 'show-letters' );

		setTimeout( () => {
			hero.classList.remove( 'show-letters' );
			hero.classList.add( 'show-content' );
		}, 3000 );

		switcher.addEventListener( 'click', () => {
			hero.classList.toggle( 'hide-all' );

			if ( hero.classList.contains( 'hide-all' ) ) {
				switcher._tippy.setContent( switcher.getAttribute( 'data-tooltip-close' ) );
                switcher._tippy.hide();
			} else {
				switcher._tippy.setContent( switcher.getAttribute( 'data-tooltip-open' ) );
                switcher._tippy.hide();
			}
		} );
	}
}